import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Modal } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';

const { Title } = Typography;

@inject(
    'CmsEventHotelStore',
    'CmsLanguageStore'
)
@observer
class EventHotelList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    createOnClick = () => {
        const { activeLanguages } = this.props.CmsLanguageStore;
        this.props.CmsEventHotelStore.initCreate(activeLanguages);
    }

    updateOnClick = id => {
        this.props.CmsEventHotelStore.getDataById(id);
    }

    confirmDeleteOnClick = id => {
        Modal.confirm({
            title: 'Remove Hotel Event',
            content: 'Are you sure to remove hotel event?',
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: () => this.deleteOnClick(id)
        });
    }

    deleteOnClick = id => {
        this.props.CmsEventHotelStore.delete(id).then(() => {
            this.props.CmsEventHotelStore.getAll();
        });
    }

    getColumns = () => {
        return [
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                width: '20%',
                ...this.getColumnSearchProps('title')
            },
            {
                title: 'Brief Desc',
                dataIndex: 'briefDescription',
                key: 'briefDescription',
                width: '20%',
                ...this.getColumnSearchProps('briefDescription')
            },
            {
                title: 'Show Banner Only',
                dataIndex: 'showBannerOnly',
                key: 'showBannerOnly',
                width: '10%',
                render: showBannerOnly => (
                    <span>{showBannerOnly ? 'Yes' : 'No'}</span>
                )
            },
            {
                title: 'Show Date',
                dataIndex: 'showDate',
                key: 'showDate',
                width: '10%',
                render: showDate => (
                    <span>{showDate ? 'Yes' : 'No'}</span>
                )
            },
            {
                title: 'Sort',
                dataIndex: 'sort',
                key: 'sort',
                width: '10%'
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'action',
                width: '10%',
                render: id => (
                    <span>
                        <Button onClick={() => this.updateOnClick(id)} type="primary" style={{ border: "none", background: "none", boxShadow: "none", margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: "#1890ff", fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.confirmDeleteOnClick(id)} type="primary" style={{ border: "none", background: "none", boxShadow: "none", margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: "#DC004E", fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { data } = this.props.CmsEventHotelStore;

        return (
            <React.Fragment>
                <Form layout="horizontal">
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: "80%", position: "relative", float: "left" }}>Hotel Event List</Title>
                        <div style={{ textAlign: "right" }}>
                            <button type="button" style={{ border: "none", background: "none", cursor: "pointer" }} onClick={this.createOnClick}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Table columns={this.getColumns()} dataSource={data} />
                </Form>
            </React.Fragment>
        )
    }
}

export default EventHotelList;